/* React */
import React, { forwardRef } from "react";
/* Thorium-UI */
import { Block, Layer, useThemeName } from "thorium-ui";
/* Custom Components */
import AboutComponents from "../components/about";
import DevPosts from "../components/about/DevPosts";

export const About = forwardRef((props, ref) => {
   const themeName = useThemeName();

   return (
      <div
         ref={ref}
         id="about-view"
         className={`suspense-wrapper about-view ${themeName}`}
      >
         <Layer
            justify="center"
            className={`info-container section ${
               props.visible ? "visible" : ""
            }`}
         >
            <Block all={12}>
               <Layer justify="center">
                  <AboutComponents.ProfileImage />
                  <AboutComponents.Bio />
               </Layer>
            </Block>
            <Block
               all={12}
               className="px-0 animate fade slideY delay-25"
               style={{ paddingTop: "2em" }}
            >
               <AboutComponents.StatsBox />
            </Block>
            <Block all={12} className="px-0 animate fade delay-375">
               <DevPosts visible={props.visible} />
            </Block>
         </Layer>
      </div>
   );
});

export default About;
